import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import { ManagerContactsPopupView } from 'es6/views/popups/manager-contacts-popup-view'
import { PopupView } from 'es6/views/popups/popup-view'
import { isDesktop } from 'init/is-desktop'
import $ from 'init/jquery'

/**
 * Вид используется для инициализации видов, работающих с модальными окнами.
 */

export class CommonPopupsView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.childViews.popups = []
    this.initManagersContactsPopup()
    this.initLeftPositionedPopups()
    this.initBreadcrumbsPopup()
    this.initCenterPositonedPopups()
  }

  /**
   * Попап на странице контактов (/kontakty/managers/).
   */
  initManagersContactsPopup () {
    $('.contacts-js-popup-opener').each((index, el) => {
      this.childViews.popups.push(
        new ManagerContactsPopupView({ el: $(el) })
      )
    })
  }

  /**
   * Обычный попап с выравниванием по левому краю инициатора.
   */
  initLeftPositionedPopups () {
    $('.js-popup-left-opener').each((index, el) => {
      this.childViews.popups.push(
        new PopupView({
          el: $(el),
          css (opener) {
            let offsetLeft = opener.offset().left
            let offsetTop = opener.offset().top + opener.innerHeight() + 10
            let bodyPosition = $('body').position()
            if (!isDesktop) {
              offsetLeft = offsetLeft - bodyPosition.left
              offsetTop = offsetTop - bodyPosition.top
            }
            return {
              left: offsetLeft,
              top: offsetTop,
            }
          },
        })
      )
    })
  }

  /**
   * Обычный попап с выравниванием по центру инициатора, со стрелками "вверх/вниз"
   */
  initCenterPositonedPopups () {
    $('.js-popup-positioned-opener').each((index, el) => {
      let $popup = $('.js-popup-positioned').eq(index),
        $opener = $(el)

      let popup_pos = new Popup($popup, $opener)

      popup_pos.addEventListener(
        Popup.EventType.BEFORE_OPEN, () => {
          let offsetLeft = $opener.offset().left - $opener.parent().outerWidth() / 2 + $opener.outerWidth() / 2,
            offsetTop = $opener.offset().top + $opener.innerHeight() + 10
          if (!isDesktop) {
            let bodyPosition = $('body').position()
            offsetLeft = offsetLeft - bodyPosition.left
            offsetTop = offsetTop - bodyPosition.top
          }
          $popup.css({
            left: offsetLeft,
            top: offsetTop,
          })
          $opener
            .find('.with-icon')
            .toggleClass('with-icon_arrowdown-blue with-icon_arrowup-blue')
        })

      popup_pos.addEventListener(
        Popup.EventType.AFTER_CLOSE, () => {
          $opener
            .find('.with-icon')
            .toggleClass('with-icon_arrowdown-blue with-icon_arrowup-blue')
        })
      this.childViews.popups.push(popup_pos)
    })

    let $popup = $('.popup, .js-popup')
    $popup.appendTo('.popups')
  }

  /**
   * Инициализация попапа хлебных крошек
   */
  initBreadcrumbsPopup () {
    let $popup_breadcrumbs = $('.js-breadcrumbs-popup'),
      $opener_breadcrumbs = $('.js-breadcrumbs-opener')

    if ($popup_breadcrumbs.length > 0) {
      $($popup_breadcrumbs).each((index, item) => {
        this.childViews.popups.push(
          new Popup($(item), $($opener_breadcrumbs[index]), undefined, 150)
        )
      })
    }
  }
}
